import React from "react";
import PerformancesPage from "./performances";
import { loadPerformances, loadUpcomingPerformances } from "../content/performanceManager";

function UpcomingPage() {
    return <PerformancesPage title="Upcoming Performances" loadFunction={loadUpcomingPerformances}/>
}

export default UpcomingPage;